import { render } from "./proposalListByReserveComponent.vue?vue&type=template&id=26a017a6"
import script from "./proposalListByReserveComponent.vue?vue&type=script&lang=js"
export * from "./proposalListByReserveComponent.vue?vue&type=script&lang=js"

import "./proposalListByReserveComponent.vue?vue&type=style&index=0&id=26a017a6&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__